import React, { useState, useLayoutEffect, useContext } from "react";
import ApiBenchmark from "../../../app/api/admin/benchmark/ApiBenchmark";
import Page from "../../modules/page";
import { ContextPage } from "../../modules/page/pageContext";
import Loader from "../../components/loader";
import DateLib from "../../../inc/DateLib";
import "./styles.css";

// Карточка замера (read-only): итоговый балл + разбивка по подтестам (data.tests) + родной балл
// приложения (data.score, ноль на redroid — норма). Устройство приходит вложенным объектом
// device (плоских device_name/node_name в карточке НЕТ — только в списке). data может быть null.
// Своя страница, а не форма Content: замер не редактируется (§4), а данные вложенные. См. §4.3.
export function BenchmarkShow({ ...other }) {
    // withContent={false} — карточка read-only: рендерим свой контент напрямую, БЕЗ движка Content
    // (иначе роутерный withContent=true обернул бы её в форму с хромом «редактировать/удалить»,
    // а замер править/удалять нельзя — §4). Ставим ПОСЛЕ {...other}, чтобы перебить проп роутера.
    return <Page {...other} withContent={false}>
        <BenchmarkShowContent/>
    </Page>;
}

function BenchmarkShowContent() {
    const contextPage = useContext(ContextPage);

    const [_benchmark, set_benchmark] = useState(null); // null — ещё грузится
    const [_notFound, set_notFound] = useState(false);  // 404: замера нет (≠ пустых данных)

    useLayoutEffect(() => {
        contextPage.setTitle('Замер');
        (async () => {
            const api = ApiBenchmark.Show(contextPage.id);
            const data = await api.getResponse();
            if (data === null) { set_notFound(true); return; }
            set_benchmark(data);
            // setTitle питает и document.title, и имя записи в хлебных крошках (breadcrumb ← app.title).
            contextPage.setTitle(`Замер #${data.id}`);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (_notFound) return <div className="benchmarks__empty">Замер не найден.</div>;
    if (_benchmark === null) return <Loader/>;

    const device = _benchmark.device ?? {};
    const tests = _benchmark.data?.tests ?? null;

    return <div className="benchmarks__card">
        <div className="benchmarks__card-score">
            <span className="benchmarks__card-score-value">{_benchmark.value}</span>
            <span className="benchmarks__card-score-label">итоговый балл ({_benchmark.type})</span>
        </div>

        <dl className="benchmarks__card-props">
            <dt>Устройство</dt>
            <dd>{device.name ? `${device.name} (#${device.id})` : `#${_benchmark.device_id}`}</dd>
            <dt>Создан</dt>
            <dd>{DateLib.formatterDateTime(_benchmark.created_at)}</dd>
            <dt title="Родной общий балл приложения; ноль на redroid — норма (нет видео-кодеков)">
                Родной балл (score)
            </dt>
            <dd>{_benchmark.data ? _benchmark.data.score : '—'}</dd>
        </dl>

        <div className="benchmarks__card-tests">
            <div className="benchmarks__card-tests-title">Подтесты</div>
            {tests
                ? <table className="benchmarks__card-tests-table">
                    <tbody>
                        {Object.entries(tests).map(([name, score]) => (
                            <tr key={name}>
                                <td className="benchmarks__card-tests-name">{name}</td>
                                <td className="benchmarks__card-tests-value">{score}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                : <div className="benchmarks__card-tests-empty">Подробности не записаны.</div>}
        </div>
    </div>;
}
